import { Accordion, AccordionDetails, AccordionSummary, Stack, styled, Typography, useTheme } from "@mui/material";
import { CaretDownIcon } from "@phosphor-icons/react/dist/csr/CaretDown";
import { AccordionRow, EmptyState, ResourceGroup, Rollup } from "./DependencyTableElements";

type DependencyTableProps = { emptyStateText?: string } & Partial<ResourceGroup>;

const AccordionStyled = styled(Accordion)(({ theme }) => ({
  borderRadius: "9px",
  boxShadow: "none",
  backgroundColor: theme.palette.surfaceLight10.main,
  border: `1px solid ${theme.palette.surfaceLight40.main}`,
}));

const DependencyTable = ({ uploads, downloads, keys, emptyStateText }: DependencyTableProps) => {
  const hasAnyDependency = uploads?.length || downloads?.length || keys?.length;
  const theme = useTheme();
  if (!hasAnyDependency) {
    if (!emptyStateText) return null;

    return <EmptyState emptyStateText={emptyStateText} />;
  }
  return (
    <AccordionStyled disableGutters defaultExpanded>
      <AccordionSummary
        expandIcon={<CaretDownIcon size="24px" color={theme.palette.text50.main} />}
        aria-controls="panel1-content"
        id="panel1-header"
        sx={{
          backgroundColor: theme.palette.surfaceLight30.main,
          padding: "16px",
          height: "56px",
          borderRadius: "8px 8px 0 0",
        }}
      >
        <Stack direction="row" sx={{ justifyContent: "space-between", width: "100%", mr: "32px" }}>
          <Typography variant="heading.seven" sx={{ color: "text50.main" }}>
            Dependencies
          </Typography>
          <Stack direction="row" sx={{ justifyContent: "flex-end", width: "90px", gap: "16px" }}>
            <Rollup uploads={uploads || []} downloads={downloads || []} keys={keys || []} />
          </Stack>
        </Stack>
      </AccordionSummary>
      <AccordionDetails
        sx={{
          "& > div > div:not(:last-child)": {
            borderBottom: `1px solid ${theme.palette.surfaceLight40.main}`,
          },
          padding: 0,
        }}
      >
        <Stack sx={{ maxHeight: "220px", overflow: "auto" }}>
          {downloads &&
            downloads.map((download) => (
              <AccordionRow type={"upload"} name={download.name} key={download.name} status={download.status} />
            ))}
          {uploads &&
            uploads.map((upload) => (
              <AccordionRow type={"download"} name={upload.name} key={upload.name} status={upload.status} />
            ))}
          {keys && keys.map((key) => <AccordionRow type="key" name={key.name} key={key.name} status={key.status} />)}
        </Stack>
      </AccordionDetails>
    </AccordionStyled>
  );
};

export { DependencyTable };
